const ContentstackIcon = ({ className = '' }) => {
  return (
    <svg viewBox="0 0 16 16" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.20018 1H4.02275C3.71192 1 3.45994 1.2569 3.45994 1.5738C3.45994 1.8907 3.71192 2.1476 4.02275 2.1476H8.20018C8.51093 2.1476 8.76295 1.8907 8.76295 1.5738C8.76295 1.2569 8.51093 1 8.20018 1Z"
        fill="#7C4DFF"
      />
      <path
        d="M8.20018 9.03413H4.02275C3.71192 9.03413 3.45994 9.29103 3.45994 9.60791C3.45994 9.9248 3.71192 10.1817 4.02275 10.1817H8.20018C8.51093 10.1817 8.76295 9.9248 8.76295 9.60791C8.76295 9.29103 8.51093 9.03413 8.20018 9.03413Z"
        fill="#7C4DFF"
      />
      <path
        d="M7.23681 2.60667H2.09508C1.78424 2.60667 1.53227 2.86357 1.53227 3.18047C1.53227 3.49737 1.78424 3.75427 2.09508 3.75427H7.23681C7.5476 3.75427 7.79963 3.49737 7.79963 3.18047C7.79963 2.86357 7.5476 2.60667 7.23681 2.60667Z"
        fill="#7C4DFF"
      />
      <path
        d="M7.23681 7.42662H2.09508C1.78424 7.42662 1.53227 7.68352 1.53227 8.00041C1.53227 8.3173 1.78424 8.57424 2.09508 8.57424H7.23681C7.5476 8.57424 7.79963 8.3173 7.79963 8.00041C7.79963 7.68352 7.5476 7.42662 7.23681 7.42662Z"
        fill="#7C4DFF"
      />
      <path
        d="M6.19179 4.21329H0.407478C0.0966457 4.21329 -0.155334 4.47019 -0.155334 4.78709C-0.155334 5.104 0.0966457 5.3609 0.407478 5.3609H6.19179C6.50268 5.3609 6.75461 5.104 6.75461 4.78709C6.75461 4.47019 6.50268 4.21329 6.19179 4.21329Z"
        fill="#7C4DFF"
      />
      <path
        d="M6.75461 6.39417C6.75461 6.07892 6.50165 5.81996 6.19179 5.81996H0.407478C0.0984835 5.81996 -0.155334 6.07803 -0.155334 6.39417C-0.155334 6.70946 0.0976346 6.96842 0.407478 6.96842H6.19263C6.50165 6.96842 6.75545 6.71031 6.75545 6.39417H6.75461Z"
        fill="#7C4DFF"
      />
      <path
        d="M11.9769 13.8524H7.79958C7.48874 13.8524 7.23681 14.1092 7.23681 14.4262C7.23681 14.7431 7.48874 15 7.79958 15H11.9769C12.2878 15 12.5398 14.7431 12.5398 14.4262C12.5398 14.1092 12.2878 13.8524 11.9769 13.8524Z"
        fill="#7C4DFF"
      />
      <path
        d="M11.9769 5.81907H7.79958C7.48874 5.81907 7.23681 6.07597 7.23681 6.39285C7.23681 6.70979 7.48874 6.96669 7.79958 6.96669H11.9769C12.2878 6.96669 12.5398 6.70979 12.5398 6.39285C12.5398 6.07597 12.2878 5.81907 11.9769 5.81907Z"
        fill="#7C4DFF"
      />
      <path
        d="M13.9047 12.2457H8.76309C8.45407 12.2457 8.20027 12.5038 8.20027 12.82C8.20027 13.1352 8.45318 13.3942 8.76309 13.3942H13.9047C14.2138 13.3942 14.4676 13.1361 14.4676 12.82C14.4676 12.5047 14.2147 12.2457 13.9047 12.2457Z"
        fill="#7C4DFF"
      />
      <path
        d="M13.9047 7.42569H8.76309C8.45224 7.42569 8.20027 7.68263 8.20027 7.99956C8.20027 8.31645 8.45224 8.57335 8.76309 8.57335H13.9047C14.2156 8.57335 14.4676 8.31645 14.4676 7.99956C14.4676 7.68263 14.2156 7.42569 13.9047 7.42569Z"
        fill="#7C4DFF"
      />
      <path
        d="M15.5926 10.6391H9.80736C9.49839 10.6391 9.24454 10.8972 9.24454 11.2133C9.24454 11.5286 9.49754 11.7875 9.80736 11.7875H15.5926C15.9016 11.7875 16.1554 11.5295 16.1554 11.2133C16.1554 10.898 15.9024 10.6391 15.5926 10.6391Z"
        fill="#7C4DFF"
      />
      <path
        d="M15.5924 9.0324H9.80806C9.49726 9.0324 9.24524 9.28929 9.24524 9.60623C9.24524 9.92312 9.49726 10.18 9.80806 10.18H15.5924C15.9032 10.18 16.1552 9.92312 16.1552 9.60623C16.1552 9.28929 15.9032 9.0324 15.5924 9.0324Z"
        fill="#7C4DFF"
      />
    </svg>
  )
}

export default ContentstackIcon
